import { forwardRef } from 'react';
import { Chip as MuiChip } from '@mui/material';
import chipDefaultStyle from './chipDefaultStyle';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { useInterstateTheme } from '../../InterstateThemeProvider';

/** Compact elements that show attributes or action  */
import { jsx as _jsx } from "react/jsx-runtime";
export const BaseChip = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    label,
    classes,
    className,
    component = 'div',
    clickable,
    deleteIcon,
    disabled,
    onClick,
    onDelete,
    icon,
    href,
    sx,
    id,
    tabIndex,
    target,
    rel
  } = props;
  const theme = useInterstateTheme();
  const chipStyle = mergeSxStyle(chipDefaultStyle(theme), sx);
  return /*#__PURE__*/_jsx(MuiChip, {
    classes: classes,
    className: className,
    component: component,
    deleteIcon: deleteIcon,
    disabled: disabled,
    label: label,
    onClick: onClick,
    onDelete: onDelete,
    icon: icon,
    ref: ref,
    size: 'small',
    href: href,
    target: target,
    rel: rel || target === '_blank' ? 'noopener noreferrer' : rel,
    sx: chipStyle,
    clickable: clickable,
    id: id,
    "data-testid": props['data-testid'],
    tabIndex: tabIndex
  });
});
BaseChip.displayName = 'BaseChip';